import { render, staticRenderFns } from "./CheckerResults.vue?vue&type=template&id=52fe8980&scoped=true&"
import script from "./CheckerResults.vue?vue&type=script&lang=js&"
export * from "./CheckerResults.vue?vue&type=script&lang=js&"
import style0 from "./CheckerResults.vue?vue&type=style&index=0&id=52fe8980&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52fe8980",
  null
  
)

/* custom blocks */
import block0 from "./CheckerResults.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports